module.exports = __webpack_public_path__ + "static/media/moshavere.ff01f820.svg";